import * as React from 'react';
import { createStyles, Text, Box } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    box: {
        display: 'flex',
        height: '100vh',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    text: {
        fontSize: '2rem',
        color: theme.colors.gray[4]
    }
}));

export const PagePlaceholder: React.FC<{ content: string; children?: React.ReactNode }> = ({ content, children }) => {
    const { classes } = useStyles();

    return (
        <Box className={classes.box}>
            <Text className={classes.text}>{content}</Text>
            <Box>{children ?? null}</Box>
        </Box>
    );
};

export default PagePlaceholder;
